const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const BLOCKOUT_TIME = 100;

const isCurrentDay = (date) => date.isSame(new Date(), 'day');

export function isSchedule (){
    'ngInject';
    return ( input ) => input && !input.schedule;
}

export function getScheduleHours(){
    'ngInject';
    return ( input, currentDate ) => {
        const schedule = JSON.parse(input.schedule);
        const currDate = window.moment(currentDate);
        const currDateStr = currDate.format('YYYY-MM-DD');
        let hours = input.schedule_type === 'daily' ? schedule[currDateStr] : schedule[days[window.moment(currentDate).day()]];

        if (!hours || hours.length === 0) {
            return [];
        }

        const today = isCurrentDay(currDate);
        let options = hours;

        if (hours.length && typeof hours[0] === 'object') {
            options = hours.map(h => h.time);
        }

        if (today) {
            const now = window.moment().add(BLOCKOUT_TIME, 'minutes');
            options = options.filter(time => {
                const timeParts = time.split(':');
                const timeMoment = window.moment().hours(timeParts[0]).minutes(timeParts[1]);
                return now.isBefore(timeMoment, 'minute');
            });
        }
        return options.sort();
    }
}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/schedule.js
 **/